export default __webpack_public_path__ + "static/media/Close.7c0a959d.svg";